module.exports = __webpack_public_path__ + "img/118-b61da5.png";